export const PIE_CHART_CONFIG: Highcharts.Options = {
  chart: {
    type: "pie",
    ignoreHiddenSeries: false,
  },
  title: {
    text: "",
  },
  tooltip: {
    valueSuffix: "%",
  },
  credits: {
    enabled: false,
  },
  plotOptions: {
    series: {
      allowPointSelect: true,
      showInLegend: false,
      cursor: "pointer",
      dataLabels: [
        {
          enabled: true,
          format: "<b>{point.title}: {point.percentage:.2f}%</b>",
        },
      ],
    },
  },
  series: [],
  exporting: {
    enabled: true,
    fallbackToExportServer: true,
    buttons: {
      contextButton: {
        align: "right",
        verticalAlign: "top",
        y: -43,
        x: -30,
      },
    },
  },
  accessibility: {
    enabled: false,
  },
};
